// Codici di glory_error: result della ChangeResponse Glory, piu' 1001/1002 impostati dall'agente.
export default function GloryErrorLabel({ code }) {
	if (!code) return null;

	function getLabel() {
		switch (Number(code)) {
			case 10:
				return "Resto non disponibile";
			case 9:
				return "Resto non disponibile in annullamento";
			case 3:
				return "Cassa occupata da un'altra operazione";
			case 6:
				return "Tagli richiesti non disponibili";
			case 11:
				return "Operazione non consentita in questo momento";
			case 12:
				return "Resto erogato non corretto";
			case 21:
			case 22:
				return "Sessione della cassa scaduta";
			case 96:
				return "Pagamento gia' inviato alla cassa";
			case 98:
				return "Importo non accettato dalla cassa";
			case 99:
			case 100:
				return "Errore della cassa";
			case 1001:
				return "Cassa Glory non collegata";
			case 1002:
				return "Comunicazione con la cassa Glory interrotta";
			default:
				return "Errore sconosciuto";
		}
	}

	return getLabel();
}
